/**
 * The letters an officer's step sends, shown in full in the step's confirmation before it is taken (release 1.6; CL-01 §9, Conditions 3.1, 3.2
 * and 3.10): the completion request, the request for the documents allowed to follow the filing, the notice of a grievance's implicit rejection
 * and the notice of an extension of the review period.
 */
export default {
  title_one: "The letter this step sends",
  title_other: "The {{count}} letters this step sends",
  hint: "Filled from the file, as the step will send them. Confirming the step sends them in your name.",
  loading: "Checking which letters this step sends…",
  updating: "Updating the letters to your latest wording…",
  failed: "The letters this step sends could not be shown",
  to: "To {{name}}",
  legalEffect: "Legal effect",
  legalEffectHint: "Sent on your confirmation of the step, as an authorised officer (Conditions 3.1 and 3.2).",
  courtesy: "Courtesy letter",
  reply: "Reply within {{period}}",
  english: "English",
  arabic: "Arabic",
  sources: {
    "completion-request": "Completion request",
    "documents-to-follow": "Request for the documents allowed to follow the filing",
    "implicit-rejection": "Notice of the implicit rejection",
    "review-extended": "Notice of the extension of the review period",
  },
  dialog: {
    title: "Confirm the step",
    description: "This step sends the letters below. They go out in your name, as shown, once you confirm.",
    confirm: "Confirm the step",
  },
};
